export default __webpack_public_path__ + "static/media/schedule.1bab0b46.svg";